// extracted by mini-css-extract-plugin
export var active = "BasketDropdown-module--active--1212b";
export var basketDropdown = "BasketDropdown-module--basket-dropdown--50769";
export var buttons = "BasketDropdown-module--buttons--086da";
export var content = "BasketDropdown-module--content--7d7b2";
export var details = "BasketDropdown-module--details--bd092";
export var image = "BasketDropdown-module--image--4f331";
export var intro = "BasketDropdown-module--intro--5d0b3";
export var label = "BasketDropdown-module--label--defd7";
export var loading = "BasketDropdown-module--loading--b9ae0";
export var name = "BasketDropdown-module--name--33c90";
export var product = "BasketDropdown-module--product--10bf9";
export var products = "BasketDropdown-module--products--01cae";
export var quantity = "BasketDropdown-module--quantity--aba64";
export var section = "BasketDropdown-module--section--abda4";
export var spinner = "BasketDropdown-module--spinner--a877f";
export var strip = "BasketDropdown-module--strip--8fd7b";
export var total = "BasketDropdown-module--total--2bb2c";
export var value = "BasketDropdown-module--value--090da";